/* GoGo Solar — homepage vertical rhythm on phones.

   Measured on a 375px viewport, the gap between the end of one section's
   content and the start of the next was:

     range        -> homes            112px
     homes        -> farms            277px   <- the one you can see
     farms        -> business         120px
     business     -> projects-intro   121px
     projects     -> bsl-reviews       72px
     bsl-reviews  -> bsl-promo        144px
     bsl-promo    -> quote            189px

   The homes gap is the worst because three paddings stack: the ported
   React grid carries pb-24 (96px) of its own, the section adds 40px, and
   farms then opens with 48px. Section padding alone was never going to
   fix it — the inner wrapper had to be caught too.

   Everything is now 64-80px. Selectors are prefixed with body so they
   outrank the id rules in bsl-polish.js and bsl-home-tweaks.js whatever
   order the stylesheets land in; this file loads last as a second line
   of defence. Desktop is untouched. */
(function () {
  var STYLE_ID = "bsl-homespace-style-v1";

  function styles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement("style");
    s.id = STYLE_ID;
    s.textContent = [
      "@media(max-width:749px){",

        /* baseline for every section */
        "body main section,body main > div > section{" +
          "padding-top:2rem !important;padding-bottom:2rem !important}",

        /* homes: the React grid's own pb-24 is the real culprit */
        "body #homes{padding-top:0 !important;padding-bottom:1rem !important}",
        "body #homes > div:first-child{" +
          "padding-top:1.75rem !important;padding-bottom:1.75rem !important}",

        /* quote carries a 96px inner top padding for the same reason */
        "body #quote{padding-top:2rem !important}",
        "body #quote > div:first-child{padding-top:.5rem !important}",

        /* the two dark bands read better with a little more air */
        "body #bsl-reviews,body #bsl-promo{" +
          "padding-top:2.5rem !important;padding-bottom:2.5rem !important}",

        "body #range{padding-top:2rem !important;padding-bottom:2.5rem !important}",

        /* the stats strip sits between two sections, so it stays tight */
        "body .bsl-stats-band{padding-top:1.5rem !important;padding-bottom:1.5rem !important}",

      "}"
    ].join("");
    document.head.appendChild(s);
  }

  new MutationObserver(styles).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== "loading") styles();
  else document.addEventListener("DOMContentLoaded", styles);
  window.addEventListener("load", styles);
})();
